// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headerWrap":"headerWrap___pyKo1","bodyWrap":"bodyWrap___QmuUT","searchTerm":"searchTerm___1Yd2q","headerContent":"headerContent___pjxSD"};